import {
  configureStore, ThunkAction, Action, combineReducers,
} from '@reduxjs/toolkit';
import threadDetailReducer from './slices/threadDetailSlice';
import threadCategoriesReducer from './slices/threadCategories';
import userInfoReducer from './slices/userInfo';
import userProfileReducer from './slices/userProfile';
import draftsReducer from './slices/drafts';
import notificationsReducer from './slices/notifications';
import routeHistoryReducer from './slices/routeHistory';
import postSearchReducer from './slices/postSearch';
import userSearchReducer from './slices/userSearch';
import imageReducer from './slices/image';
import groupsReducer from './slices/groups';
import appNotificationsReducer from './slices/appNotifications';
import weblabReducer from './slices/weblab';

export const rootReducer = combineReducers({
  threadDetail: threadDetailReducer,
  threadCategories: threadCategoriesReducer,
  userInfo: userInfoReducer,
  userProfile: userProfileReducer,
  drafts: draftsReducer,
  notifications: notificationsReducer,
  routeHistory: routeHistoryReducer,
  postSearch: postSearchReducer,
  userSearch: userSearchReducer,
  image: imageReducer,
  groups: groupsReducer,
  appNotifications: appNotificationsReducer,
  weblab: weblabReducer,
});

export function makeStore() {
  return configureStore({
    reducer: rootReducer,
  });
}

const store = makeStore();

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppStore = ReturnType<typeof makeStore>;

export type AppThunk<ReturnType = void> = ThunkAction<
ReturnType,
AppState,
unknown,
Action<string>
>;

export default store;
